module.exports = __webpack_public_path__ + "img/feature-workout@2x.8a34f82c.jpg";